import "slick-carousel";

const SinglePortfolio = {
  init: function () {
    SinglePortfolio.related();
  },

  related: function () {
    $(".portfolio-related__slider").slick({
      slidesToShow: 3,
      rows: 0,
      prevArrow:
        '<button class="slick-prev" aria-label="prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10"><path d="M18,15l-6,5.06L18,25V21H28V19H18Z" transform="translate(-12 -15)"/></svg></button>',
      nextArrow:
        '<button class="slick-next" aria-label="next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10"><path d="M18,15l-6,5.06L18,25V21H28V19H18Z" transform="translate(28 25) rotate(180)"/></svg></button>',
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            arrows: false,
            slidesToShow: 1,
          },
        },
      ],
    });
  },
};

export default SinglePortfolio;
